// extracted by css-extract-rspack-plugin
module.exports =  {"footerHr":"b44f2c2d8a","footer":"cb0337eb12","addPetHeader":"d0ec014eed"};